<template>
  <div class="affectation-unites">
    <p class="text-grey">Cochez les unités où {{ personnel.name }} travaille. L’unité principale est proposée par défaut au poste de soins.</p>
    <div v-if="chargement" class="text-grey">Chargement…</div>
    <template v-else>
      <p v-if="!unites.length" class="text-grey">Aucune unité active. Créez-la d’abord dans Équipe et Accès → Unités de soins.</p>
      <div v-for="unite in unites" :key="unite.id" class="affectation-ligne">
        <label class="mb-0"><input type="checkbox" :value="unite.id" v-model="choisies"> {{ unite.name }}</label>
        <label class="mb-0 text-grey"><input type="radio" :name="'unite-principale-' + personnel.id" :value="unite.id" v-model="principale"
          :disabled="choisies.indexOf(unite.id) === -1"> Principale</label>
      </div>
      <div v-if="erreur" class="alert alert-danger mt-3" role="alert">{{ erreur }}</div>
      <div v-if="succes" class="alert alert-success mt-3" role="status">{{ succes }}</div>
      <div class="text-right mt-3">
        <button type="button" class="btn-primary btn-radius" :disabled="enregistrement || !unites.length" @click="enregistrer">
          {{ enregistrement ? 'Enregistrement…' : 'Enregistrer les unités' }}</button>
      </div>
    </template>
  </div>
</template>

<script>
import UnitesSoinsApi from '@/api/stock/_unites-soins'

// 3e onglet de la fiche du personnel (Équipe et Accès → Personnel → Editer profil).
export default {
  name: 'AffectationUnites',
  props: { personnel: { type: Object, required: true } },
  data() { return { unites: [], choisies: [], principale: null, chargement: true, enregistrement: false, erreur: '', succes: '' } },
  watch: { choisies(ids) { if (ids.indexOf(this.principale) === -1) this.principale = ids.length === 1 ? ids[0] : null } },
  mounted() { this.charger() },
  methods: {
    async charger() {
      this.chargement = true; this.erreur = ''
      try {
        const [unites, affectations] = await Promise.all([UnitesSoinsApi.liste(), UnitesSoinsApi.affectations(this.personnel.id)])
        this.unites = unites.filter(unite => unite.is_active)
        this.choisies = affectations.map(ligne => Number(ligne.service_id))
        const principale = affectations.find(ligne => ligne.is_primary)
        this.$nextTick(() => { this.principale = principale ? Number(principale.service_id) : null })
      } catch (error) { this.erreur = UnitesSoinsApi.messageErreur(error) }
      finally { this.chargement = false }
    },
    async enregistrer() {
      this.enregistrement = true; this.erreur = ''; this.succes = ''
      try {
        await UnitesSoinsApi.affecter(this.personnel.id, this.choisies, this.choisies.indexOf(this.principale) !== -1 ? this.principale : null)
        this.succes = 'Unités de soins enregistrées.'
      } catch (error) { this.erreur = UnitesSoinsApi.messageErreur(error) }
      finally { this.enregistrement = false }
    }
  }
}
</script>

<style scoped>
.affectation-unites { text-align: left }
.affectation-ligne { display: flex; justify-content: space-between; gap: 12px; padding: 10px 0; border-bottom: 1px solid #edf0f6 }
</style>
